var _defs, _rect, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    fill: "none",
    viewBox: "0 0 35 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 24,
    fill: "#1B1D1E",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34.7,
    height: 23.7,
    x: 0.15,
    y: 0.15,
    stroke: "#fff",
    strokeOpacity: 0.3,
    strokeWidth: 0.3,
    rx: 2.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.568 16.357h-2.11l-1.58-6.033c-.076-.277-.235-.523-.47-.639a6.865 6.865 0 00-1.932-.638v-.232h3.397c.469 0 .82.349.879.754l.82 4.352 2.108-5.106h2.05l-3.162 7.542zm4.335 0H12.91l1.64-7.543h1.992l-1.64 7.542zm4.216-5.454c.059-.406.41-.638.82-.638a3.711 3.711 0 011.934.348l.351-1.624a5.04 5.04 0 00-1.816-.349c-1.933 0-3.339 1.045-3.339 2.495 0 1.103.996 1.682 1.7 2.03.76.349 1.054.581.995.929 0 .522-.586.754-1.171.754a5.024 5.024 0 01-2.05-.464l-.352 1.624c.703.29 1.464.407 2.167.407 2.168.057 3.515-.987 3.515-2.553 0-1.973-2.754-2.089-2.754-2.959zm9.724 5.453l-1.581-7.542h-1.7a.881.881 0 00-.82.58l-2.928 6.962h2.05l.41-1.102h2.519l.234 1.102h1.816zm-2.987-5.51l.585 2.842h-1.64l1.055-2.843z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaDark);
export default __webpack_public_path__ + "static/media/visa-dark.5786d269.svg";
export { ForwardRef as ReactComponent };